import React, { useEffect, useState } from 'react'
import { Formik, Form } from 'formik'
import Button from '@components/button'
import Fields from '@components/fields'
import Grid from '@components/grid'
import Row from '@components/row'
import Wrapper from '@components/wrapper'
import styled from '@emotion/styled'
import theme from '@utils/theme'
import { useSelector } from 'react-redux'
import { RootState } from '@store/index'
import { GeneralSetting } from '@apis/index'
import generalSettings from '@apis/generalSettings'

const PaymentForm = () => {
  const [initialState, setInitialState] = useState({
    title: '',
    subtitle: '',
    rs: '',
    point: '',
    image: '',
    khaltiActive: false,
    manualActive: false,
    dynamicQrActive: false,
  })
  const { data: paymentSetting } = useSelector(
    (state: RootState) => state.paymentSetting,
  )

  const fetchPaymentSetting = async () => {
    try {
      await GeneralSetting.getByKey({
        id: 'payment-setting',
        state: 'paymentSetting',
      }).then((res) => {
        const parsedValue = JSON.parse(res.value ?? null)
        setInitialState({
          title: parsedValue.paymentTitle,
          subtitle: parsedValue.paymentSubtitle,
          rs: parsedValue.pointsConversion.rs,
          point: parsedValue.pointsConversion.points,
          image: `${res.file}`,
          khaltiActive: !!parsedValue.khaltiActive,
          manualActive: !!parsedValue.manualActive,
          dynamicQrActive: !!parsedValue.dynamicQrActive,
        })
      })
    } catch (error) {}
  }

  const handleSubmit = async (values) => {
    try {
      const payload = {
        group: 'payment-setting',
        key: 'payment-setting',
        value: JSON.stringify({
          paymentTitle: values.title,
          paymentSubtitle: values.subtitle,
          pointsConversion: {
            rs: values.rs,
            points: values.point,
          },
          khaltiActive: values.khaltiActive,
          manualActive: values.manualActive,
          dynamicQrActive: values.dynamicQrActive,
        }),
        file: values.image.base64
          ? {
              extension: values.image.extension,
              base64: values.image.base64,
            }
          : values.image,
      }
      if (!!paymentSetting) {
        await generalSettings.update({
          state: 'paymentSetting',
          data: payload,
          id: paymentSetting.id,
        })
      } else {
        await generalSettings.create({ state: 'paymentSetting', data: payload })
      }
    } catch (error) {}
  }

  useEffect(() => {
    fetchPaymentSetting()
  }, [])
  return (
    <Wrapper>
      <Formik
        initialValues={initialState}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        <Form>
          <FormBody>
            <Grid
              repeat={2}
              styleGrid={`
                width: 200%;
                & > :nth-child(1),
                & > :nth-child(2),
                & > :nth-child(3) {
                  grid-column: span 2;
                }
              `}
            >
              <Fields.Input
                name="title"
                label="Payment Title"
                placeholder="Enter here"
              />
              <Fields.Input
                name="subtitle"
                label="Payment Subtitle"
                placeholder="Enter here"
              />
              <Label>Points Conversion</Label>
              <Fields.Input name="rs" placeholder="Enter Rs" type="number" />
              <Fields.Input
                name="point"
                placeholder="Enter Points"
                type="number"
              />
            </Grid>

            <Fields.Upload name="image" variant="banner" />
          </FormBody>

          <ToggleRow>
            <Fields.Switch
              name="khaltiActive"
              label="Khalti"
              styleWrapper="flex-direction: row; align-items: center; gap: 10px;"
            />
            <Fields.Switch
              name="manualActive"
              label="Manual"
              styleWrapper="flex-direction: row; align-items: center; gap: 10px;"
            />
            <Fields.Switch
              name="dynamicQrActive"
              label="Dynamic QR"
              styleWrapper="flex-direction: row; align-items: center; gap: 10px;"
            />
          </ToggleRow>

          <Row styleRow="justify-content:flex-end; margin-top:20px; gap: 12px;">
            {/* <Button
              title="Change QR"
              height={45}
              width={100}
              styleButton={outlineButton}
            /> */}
            <Button
              title={!!paymentSetting ? 'Update' : 'Submit'}
              height={45}
              width={100}
              type="submit"
            />
          </Row>
        </Form>
      </Formik>
    </Wrapper>
  )
}

export default PaymentForm

// Styled Components
const FormBody = styled.div`
  display: flex;
  gap: 20px;
`

const ToggleRow = styled.div`
  display: flex;
  gap: 32px;
  margin-top: 20px;
  padding: 0 20px;
`

const Label = styled.p`
  font-size: 14px;
  font-weight: 500;
  color: ${theme.colors.text};
  margin: 0;
  padding-left: 4px;
`

export const outlineButton = `
  background: transparent;
  border: 1px solid ${theme.colors.primary};
  color: ${theme.colors.primary};
`
